// extracted by mini-css-extract-plugin
export default {"Container":"FooterInfo_Container__9-tpH","Badges":"FooterInfo_Badges__AOZzi"};